export default __webpack_public_path__ + "media/images/ui-icons_2e83ff_256x240-2b99a5e48d3c3957d03027d36a25e8bb.png";